import { render, staticRenderFns } from "./fund.vue?vue&type=template&id=028d12ad&scoped=true"
import script from "./fund.vue?vue&type=script&lang=ts"
export * from "./fund.vue?vue&type=script&lang=ts"
import style0 from "./fund.vue?vue&type=style&index=0&id=028d12ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d12ad",
  null
  
)

export default component.exports